import { render, staticRenderFns } from "./SearchGrid.vue?vue&type=template&id=35965036&"
import script from "./SearchGrid.vue?vue&type=script&lang=js&"
export * from "./SearchGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports